import React, { useEffect, useState } from 'react'
import { MDBInput, MDBTextArea } from 'mdb-react-ui-kit'
import { DatePicker, Select } from 'antd'
import moment from 'moment'
import axios from 'axios'
import apiUrls from '../../Api/MainApi'
const NomineeDetails = ({ formData, setFormData }) => {
  const [nomineeRelation , setNomineeRelation] = useState([]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({   //  setting the data to the main formData
      ...prev,
      [name]: value,
    }))
  }
  const handleRelationChange = (value) => {
    setFormData(prev => ({
      ...prev,
      nomineeRelationID: value
    }))
  }
  const handleDateChange = (date, dateString) => {
    setFormData(prevData => ({
      ...prevData,
      nomineeDateOfBirth: dateString ? moment(dateString).format('YYYY-MM-DD') : '0000-00-00' //  setting the data to the main formData

    }));
  }
  useEffect(() => {
    const CarQuotationRequest = JSON.parse(sessionStorage.getItem('CarQuotationRequest'))  // get the id from the insurer 
    const fetchNomineeRelational = async () => {  // function to get the data from the api 
      const response = await axios.post(apiUrls.NomineeRelations, { InsurerID: CarQuotationRequest.InsurerID })  // api call for the data 
      const NomineeRelations = response.data.data
      setNomineeRelation(NomineeRelations)
      // console.log(NomineeRelations , "line 34")
    }
    fetchNomineeRelational()
  }, [])
  // const nomineeRelations = [
  //   { label: 'Brother', value: 'brother' },
  //   { label: 'Sister', value: 'sister' },
  //   { label: 'Father', value: 'father' },
  //   { label: 'Mother', value: 'mother' },
  //   { label: 'Spouse', value: 'spouse' }
  // ];
  const filterOption = (input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  return (
    <>
      <div className='container'>
        {/* <h5 className='policy-detail-title'>Nominee Details</h5> */}
        <div className='row mt-3'>
          <div className='col-md-6 col-sm-12 policy-detail-input' autoSave='off'>
            <label className='mb-2'>Enter First Name</label>
            <MDBInput
              autoComplete='off'
              name='nomineeFirstName'
              value={formData.nomineeFirstName}
              onChange={handleChange}
              label={<>First Name <span className='text-danger'>*</span></>}
              id='name'
              type='text'
            />
            {/* {errors.FirstName && <div className="text-danger">{errors.FirstName}</div>} */}
          </div>
          <div className='col-md-6 col-sm-12 policy-detail-input' autoSave='off'>
            <label className='mb-2'>Enter Last Name</label>
            <MDBInput
              autoComplete='off'
              name='nomineeLastName'
              value={formData.nomineeLastName}
              onChange={handleChange}
              label={<>Last Name <span className='text-danger'>*</span></>}
              id='name'
              type='text'
            />
            {/* {errors.LastName && <div className="text-danger">{errors.LastName}</div>} */}
          </div>
          <div className='col-md-6 col-sm-12 policy-detail-input mt-2'>
            <label>Enter Nominee relationship <span className='text-danger'>*</span></label>
            <Select
              name="nomineeRelation"
              showSearch
              filterOption={filterOption}
              value={formData.nomineeRelationID}
              onChange={handleRelationChange}
              options={(nomineeRelation.length > 0 ? nomineeRelation : [{ id: 0, name: "No Relation Found" }]).map(item => ({ key: `item-${item.id}`, value: item.id, label: item.name }))}
              className='mt-2'
              placeholder="Select Nominee Relation"
            />
          </div>
          <div className='col-md-6 col-sm-12 policy-detail-input mt-2'>
            <label>Date Of Birth <span className='text-danger'>*</span></label>
            <DatePicker
              className='mt-2'
              style={{ width: '100%' }}
              onChange={handleDateChange}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default NomineeDetails